import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MyOrganisationService } from '@services/organisations/my-organisation.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-organisation-selector',
    templateUrl: './organisation-selector.component.html',
    styleUrls: ['./organisation-selector.component.scss'],
    providers: [MyOrganisationService],
    standalone: false
})
export class OrganisationSelectorComponent implements OnInit {

  organisation: Models.MyOrganisation;
  multipleOrganisations = false;
  organisations = [];

  constructor(public myOrganisationService: MyOrganisationService, private messengerService: MessengerService, public router: Router) {
    this.messengerService.$activeOrganisation.subscribe(org => {
      if (org) {
        this.setOrganisation();
      }
    });

    this.myOrganisationService.find(0, 16).then(result => {
      if (result && result.data && result.data.length <= 15 && result.data.length > 1) {
        this.organisations = result.data;
      }
    });
  }

  ngOnInit() {
    this.setOrganisation();
  }

  setOrganisation() {
    this.organisation = this.messengerService.getOrganisation();
    this.myOrganisationService.find(0, 2).then(myOrganisationResult => {
      if (myOrganisationResult.data && myOrganisationResult.data.length > 1) {
        this.multipleOrganisations = true;
      }
    });
  }

  public clearOrganisation() {
    this.messengerService.setOrganisation(null);
    this.router.navigateByUrl('selectOrganisation');
  }

  public selectOrganisation(org) {
    this.messengerService.setOrganisation(org);
    setTimeout(() => {
      this.router.navigate([{ outlets: { primary: 'dashboard', org: org.name } }])
    }, 0);
  }

}
